import { useState, useEffect } from 'react';
import { _APIS } from 'apis';
import request from 'request';
import { jsonParseData } from 'utils';

const getSaasApolloConfig = (params: any) => request.get(_APIS.PRODUCT_PRICE.COMMON.CONFIG, { params });
export const useGetHolidays = () => {
  const [holidayEnum, setHolidayEnum] = useState<any[]>([]);
  const filterUpcomingHolidays = (holidays: any[]) => {
    const currentDate = new Date();
    const threeMonthsLater = new Date();
    threeMonthsLater.setMonth(currentDate.getMonth() + 3);

    return holidays.filter((holiday: any) => {
      const startDate = new Date(holiday.date_ranges[0]);
      return startDate >= currentDate && startDate <= threeMonthsLater;
    });
  }

  useEffect(() => {
    getSaasApolloConfig({
      config_name: 'front_enums',
      param_name: 'f_holiday_enum',
    }).then((res: any) => {
      setHolidayEnum(filterUpcomingHolidays(jsonParseData(res?.data?.f_holiday_enum, [])));
    })
  }, []);

  return {
    holidayEnum
  };
}